<h3 i18n="demo results@@demo_results">Demo Results for {{ results.collectionName.display }} on Survey</h3>
@if (displayData) {
  <div>
    <div>Field name - number passing the condition</div>
    @for (dData of displayData; track dData) {
      <div>
        @if (dData.type === 'decimal') {
          <div>
            {{ dData.field }}: {{ dData.value }}
          </div>
        }
        @if (dData.type === 'list') {
          <div>
            {{ dData.field }}
            @for (entry of dData.values; track entry) {
              <div style="padding-left: 1rem">
                {{ entry.field }}: {{ entry.value }}
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
